// import logo from './logo.svg';
import './App.css';
import './yizcss/icon.css';
import './yizcss/contact.css';
import './yizcss/footer.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import Yiz from './yiz/yiz';
<link href="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet"></link>









function App() {

  return (
    <Router>
      <div className="App">
       
     
    <Yiz/>
    
    
      </div>
   </Router>
  );
}

export default App;
